import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  public set token(token: string) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('token', token);
    }
  }

  public get token(): string {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('token') || '';
    }
    return '';
  }

  public set userType(data: any) {
    localStorage.setItem('userType', JSON.stringify(data));
  }

  public get userType() {
    return JSON.parse(localStorage.getItem('userType') || '');
  }

  public set currency(currency: string) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('currency', currency);
    }
  }

  public get currency(): string {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('currency') || 'USD';
    }
    return 'USD';
  }

  public removeToken(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('userType');
    localStorage.removeItem('currency');
  }
}
